import { render, staticRenderFns } from "./DataDamage.vue?vue&type=template&id=ac1ff3f2&"
import script from "./DataDamage.vue?vue&type=script&lang=js&"
export * from "./DataDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports